import { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import axios from '../../../utils/axiosInstance';
import { useTranslation } from 'react-i18next';
import { IndividualProduct } from '@cdaas/reusable-components-daas';
import { getActiveOrganizationId } from '../../../utils';

const Product: FunctionComponent = () => {
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState();
  const [error, setError] = useState('');
  const { id } = useParams<{ id: string }>();
  const { t, i18n } = useTranslation('product');

  const productTranslation = {
    productDescription: t('productComponent.productDescription'),
    readyButtonText: t('productComponent.readyButtonText'),
  };

  useEffect(() => {
    setLoading(true);
    setError('');
    axios
      .get(`/api/organization/${getActiveOrganizationId()}/products/product/${id}`)
      .then(resp => {
        if (resp.data?.product) {
          setProduct(resp.data);
        }
      })
      .catch(err => {
        console.error('Product loading error', err);
        setError('Product loading failed');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [i18n.language, id]);

  return <IndividualProduct localProductEnvelope={product} loading={loading} errorText={error} translations={productTranslation} />;
};

export default Product;
